import React from 'react';

import cls from 'classnames';
import styles from './LikeIcon.scss';

const DEFAULT_ICON_SIZE = 24;

type Props = {
  borderClassName?: string;
  className?: string;
  hasHover?: boolean;
  hasShadow?: boolean;
  preset?: 'onDark' | 'onLight';
  isActive?: boolean;
  shapeClassName?: string;
  width?: number;
  height?: number;
};

const presetClassNames = {
  onDark: styles.onDark,
  onLight: styles.onLight,
};

const LikeIcon = ({
  borderClassName,
  className,
  hasHover = true,
  hasShadow = true,
  isActive,
  preset = 'onDark',
  shapeClassName,
  width = DEFAULT_ICON_SIZE,
  height = DEFAULT_ICON_SIZE,
}: Props) => {
  return (
    <svg
      className={cls(
        styles.icon,
        {
          [styles.hasHover]: hasHover,
          [styles.hasShadow]: hasShadow,
          [styles.isActive]: isActive,
        },
        presetClassNames[preset],
        className
      )}
      viewBox="0 0 24 24"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M12 21l-1.45-1.295C5.4 15.125 2 12.093 2 8.395 2 5.364 4.42 3 7.5 3c1.74 0 3.41.795 4.5 2.04A6.062 6.062 0 0116.5 3C19.58 3 22 5.364 22 8.395c0 3.698-3.4 6.73-8.55 11.31L12 21z"
          className={cls(styles.shape, shapeClassName)}
        />
        <path
          d="M12.1 18.55l-.1.1-.11-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04 1 3.57 2.36h1.86C13.46 6 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05zM16.5 3c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5 22 5.41 19.58 3 16.5 3z"
          className={cls(styles.border, borderClassName)}
        />
      </g>
    </svg>
  );
};

LikeIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default LikeIcon;
